import { render, staticRenderFns } from "./TopicAssistant.vue?vue&type=template&id=518d210b&scoped=true"
import script from "./TopicAssistant.vue?vue&type=script&lang=js"
export * from "./TopicAssistant.vue?vue&type=script&lang=js"
import style0 from "./TopicAssistant.vue?vue&type=style&index=0&id=518d210b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d210b",
  null
  
)

export default component.exports